import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import * as globalConst from './../../../../constants';

@Injectable()
export class AccountClientLogService {
	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchLog(token: string, begindate, enddate, user: string) {
		var filter = {
			LogLevel: 1, // ContaCLiente
			Usuario: user,
			DataInicio: begindate == '' ? begindate : new Date(begindate),
			DataFim: enddate == '' ? enddate : new Date(enddate)
		};
		console.log(filter);
		return this.http
			.post(this.apiUrl + "/logs/v1/logsaccountclient", filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());

	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/service/account-client-log/account-client-log.service.ts